import * as React from 'react';
import { LogoCentered } from 'src/app/Partials';
import { RequestApiResult } from 'loopback-react-request';
import { connect } from 'react-redux';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ResetPasswordChangeSucceeded.messages';
import { Link } from 'react-router-dom';

export interface ResetPasswordChangeSucceededPageProps {
  dispatch: any;
  resetPassword: RequestApiResult<any>;
}

export class ResetPasswordChangeSucceededPageComponent extends React.Component<ResetPasswordChangeSucceededPageProps> {

  public render() {
    return (
      <div className="page-resetpassword d-flex justify-content-center align-items-center h-100">
        <div className="inner w-100 pt-5 pb-5">
          <div className="row m-0 mb-4">
            <div className="col-12">
              <LogoCentered />
            </div>
          </div>
          <h4>
            <FormattedMessage {...MESSAGES.resetPasswordChange} />
          </h4>
          <p className="mb-4">
            <FormattedMessage {...MESSAGES.resetPasswordChangeSucceeded} />
          </p>
          <Link className="btn btn-secondary w-100 d-block" to="/">
            <FormattedMessage {...MESSAGES.resetPasswordChangeButton} />
          </Link>
        </div>
      </div>
    );
  }
}


interface StateProps {
  resetPassword: RequestApiResult<any>;
} 

export const ResetPasswordChangeSucceededPage = connect((state: StateProps) => ({
  resetPasswordChange: state.resetPassword,
}))( ResetPasswordChangeSucceededPageComponent);

export default ResetPasswordChangeSucceededPage;